import { ExodusResources } from './exodus.resource';

export const OrganizationUrl = {
    ORGANIZATION: ExodusResources.ORGANIZATION,
    ORGANIZATION_SEARCH: ExodusResources.ORGANIZATION + '/search',
    ORGANIZATION_DROP_DOWN_LIST: ExodusResources.ORGANIZATION + '/drop-down-list',
    ORGANIZATION_Discounts: ExodusResources.ORGANIZATION + '/discounts',
    ORGANIZATION_COUNTRY_HAS_DISCOUNT: ExodusResources.ORGANIZATION + '/country-has-organization',
    ORGANIZATION_GET: ExodusResources.ORGANIZATION,
    ORGANIZATION_ADD: ExodusResources.ORGANIZATION,
    ORGANIZATION_UPDATE: ExodusResources.ORGANIZATION + '/{id}',
};



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/company-account.url.ts